import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {updateBasket} from '../../actions/basket.action';
import {resetBasketItemOriginalState, loadExistingBasketItem, updateBasketItemComments} from '../../actions/basketItem.action';
import {updateBasketItemQuantityInModal} from '../../actions/quantity.action';
import {ContextProvider} from '../../components/ContextProvider/ContextProvider';
import {defaultStyles} from './modal.config';
import {BASKET_MODE} from '../../constants/constant';
import AppModal from '../../components/Modal/AppModal';
import BasketModalItem from '../Meal/BasketModalItem';

class BasketModal extends PureComponent {
  constructor(props) {
    super(props);

    this.handleUpdateBasket = this.handleUpdateBasket.bind(this);
    this.resetModal = this.resetModal.bind(this);
  }

  handleUpdateBasket(basketItemUuid, itemOrigin) {
    const {updateBasketFunc, orderSource} = this.props;
    updateBasketFunc(
      basketItemUuid ? BASKET_MODE.EDIT : BASKET_MODE.CREATE,
      this.context.providers.restaurant.getMeta().code,
      itemOrigin,
      orderSource
    );
  }

  resetModal() {
    this.props.resetState();
  }

  render() {
    const {updateItemQuantity, basketItem, updateItemComments, menu, restaurantModes, offlineMenu, serverOffline} = this.props;
    const mealUuid = basketItem.mealUuid;
    const editingMeal = offlineMenu ? offlineMenu.meals[mealUuid] : menu.meals[mealUuid];

    return (
      mealUuid &&
        <AppModal
          customStyles={defaultStyles}
          callback={this.resetModal}
          showCloseButton={true}
        >
          <BasketModalItem
            meal={editingMeal}
            updateBasket={this.handleUpdateBasket}
            updateQuantity={updateItemQuantity}
            cancel={this.resetModal}
            basketItem={basketItem}
            updateItemComments={updateItemComments}
            restaurantModes={restaurantModes}
            isOfflineMenu={!!offlineMenu}
            serverOffline={serverOffline}
          />
        </AppModal>
    );
  }
}

BasketModal.propTypes = {
  updateBasketFunc: PropTypes.func.isRequired,
  updateItemQuantity: PropTypes.func.isRequired,
  updateItemComments: PropTypes.func.isRequired,
  resetState: PropTypes.func.isRequired,
  loadExistingBasketItemFunc: PropTypes.func.isRequired,
  basketItem: PropTypes.object.isRequired,
  menu: PropTypes.object.isRequired,
  restaurantModes: PropTypes.object.isRequired,
  offlineMenu: PropTypes.object,
  orderSource: PropTypes.string,
  serverOffline: PropTypes.bool.isRequired
};

BasketModal.contextTypes = {
  providers: PropTypes.object
};

const mapStateToProps = state => {
  return {
    basketItem: state.basketItem,
    serverOffline: state.serverOffline
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateBasketFunc: bindActionCreators(updateBasket, dispatch),
    updateItemQuantity: bindActionCreators(updateBasketItemQuantityInModal, dispatch),
    updateItemComments: bindActionCreators(updateBasketItemComments, dispatch),
    resetState: bindActionCreators(resetBasketItemOriginalState, dispatch),
    loadExistingBasketItemFunc: bindActionCreators(loadExistingBasketItem, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContextProvider(BasketModal));



// WEBPACK FOOTER //
// ./components/Modal/BasketModal.js